import script from "./xmLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./xmLogin.vue?vue&type=script&setup=true&lang=js"

import "./xmLogin.vue?vue&type=style&index=0&id=51c765aa&lang=less"

const __exports__ = script;

export default __exports__